import { useState } from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import { loaders } from "@gonoodle/gn-universe-utils";
import { intervalToDuration, isValid, parse } from "date-fns";
import { useRouter } from "next/router";

import Button from "../Button";
import DateField from "../DateField";

export default function AgeGateBox({ locked, onChange }) {
  const [error, setError] = useState();
  const [age, setAge] = useState();
  const router = useRouter();

  return (
    <div className="flex flex-col space-y-md items-center text-center">
      <div className="space-y-sm">
        <h1 className="gn-headline-sm">
          {locked ? "Sorry, buddy!" : "Are you a grown up?"}
        </h1>
        <p className="gn-text" data-testid="age-gate-box-description">
          {locked
            ? "You need a grown up to help you."
            : "If not, get a grown up to help you register!"}
        </p>
      </div>
      {locked === false ? (
        <>
          <div className="text-left">
            <DateField
              label="Date of Birth"
              required
              error={error}
              onChange={(value) => {
                const date = parse(value, "mm/dd/yyyy", new Date());
                if (isValid(date)) {
                  setError(undefined);
                  const { years } = intervalToDuration({
                    start: new Date(),
                    end: date,
                  });
                  setAge(years);
                } else {
                  setAge(undefined);
                }
              }}
            />
          </div>
          <p className="gn-text-sm" data-testid="age-gate-box-description">
            We won&apos;t store this information. Learn more by reading our{" "}
            <a href="/company/p/tos" className="cursor-pointer underline">
              Terms&nbsp;of&nbsp;Service
            </a>
            &nbsp;and&nbsp;
            <a
              href="/company/p/privacy-policy"
              className="cursor-pointer underline"
            >
              Privacy&nbsp;Policy
            </a>
          </p>
          <div className="w-full flex space-x-sm xs:space-x-md">
            <Button
              mode="dark-outline"
              label="Cancel"
              size="md"
              onClick={() => router.back()}
              className="w-full"
            />
            <Button
              mode="dark"
              label="Continue"
              size="md"
              onClick={() =>
                age ? onChange(age) : setError("Please enter a valid date")
              }
              className="w-full"
            />
          </div>
        </>
      ) : null}
      {locked === true ? (
        <div className="flex flex-col space-y-md w-full">
          <div className="self-center mr-4">
            <Image
              loader={loaders.S3Loader}
              priority
              width={150}
              height={180}
              objectFit="contain"
              src="McPufferson-L1-sad.svg"
              alt=""
            />
          </div>
          <Button
            mode="dark"
            label="Watch GoNoodle Videos"
            size="md"
            onClick={() => router.back()}
          />
        </div>
      ) : null}
    </div>
  );
}

AgeGateBox.propTypes = {
  locked: PropTypes.bool,
  onChange: PropTypes.func,
};

AgeGateBox.defaultProps = {
  locked: false,
  onChange: () => {},
};
